import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

type Me = { discordId: string; tag?: string | null; isAdmin: boolean } | null

export default function App() {
  const [me, setMe] = useState<Me>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/me')
      .then(r => r.json())
      .then(d => setMe(d?.me ?? null))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Shell>
      <div className="card">
        <div className="title">
          <h1>Panel administratora</h1>
          <span className="badge">logowanie</span>
        </div>

        {!me && (
          <>
            <p className="muted">Zaloguj się przez Discord, aby wejść do panelu.</p>
            <a href="/auth/login" className="btn">
              <DiscordIcon />
              Zaloguj przez Discord
            </a>
          </>
        )}

        {loading && <p className="muted" style={{ marginTop: 12 }}>Sprawdzam sesję…</p>}

        {me && (
          <>
            <div className="me">
              <div>
                Zalogowano jako: <b>{me.tag || 'Nieznany nick'}</b>
                <code>{me.discordId}</code>
              </div>
              {me.isAdmin && <span className="pill">administrator</span>}
            </div>

            <div className="actions">
              <Link to="/admin" className="btn secondary">Wejdź do panelu</Link>
              <a href="/auth/logout" className="btn secondary">Wyloguj</a>
            </div>
          </>
        )}
      </div>
    </Shell>
  )
}

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="wrap">
      <style>{css}</style>
      {children}
    </div>
  )
}

function DiscordIcon() {
  return (
    <svg className="logo" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20.317 4.369A19.91 19.91 0 0016.558 3c-.2.356-.43.83-.59 1.21a18.255 18.255 0 00-7.936 0 7.74 7.74 0 00-.598-1.21 19.89 19.89 0 00-3.76 1.37C1.533 8.276.88 12.04 1.12 15.75a19.94 19.94 0 005.995 3.018c.48-.66.91-1.36 1.28-2.09-.7-.27-1.37-.6-2-.98.17-.12.34-.25.5-.38a14.2 14.2 0 0012.19 0c.17.13.33.26.5.38-.63.38-1.3.71-2 .98.37.73.79 1.42 1.27 2.08a19.93 19.93 0 006.01-3.014c.29-4.34-.72-8.07-3.56-11.034zM9.3 13.65c-.96 0-1.74-.88-1.74-1.96 0-1.07.78-1.95 1.74-1.95.97 0 1.75.88 1.74 1.95 0 1.08-.77 1.96-1.74 1.96zm5.4 0c-.97 0-1.75-.88-1.75-1.96 0-1.07.78-1.95 1.75-1.95.96 0 1.74.88 1.74 1.95 0 1.08-.78 1.96-1.74 1.96z" fill="currentColor"/>
    </svg>
  )
}

const css = `
:root{--bg:#0b0d12;--card:#111525;--border:#1f2430;--text:#e8e8ec;--muted:#a6a8ad;--acc:#5865F2;--ok:#2e9c4b}
*{box-sizing:border-box}
body{background:linear-gradient(180deg,#0b0d12,#0a0c14);color:var(--text);font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial;margin:0}
.wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px}
.card{width:100%;max-width:560px;background:radial-gradient(60% 120% at 0 0,rgba(122,44,255,.12),transparent),var(--card);border:1px solid var(--border);border-radius:20px;box-shadow:0 20px 60px rgba(0,0,0,.45);padding:28px}
.title{display:flex;align-items:center;justify-content:space-between;margin-bottom:6px}
h1{font-size:28px;margin:0}
.badge{padding:4px 10px;background:#1b1f2d;border:1px solid #2a3042;border-radius:999px;color:#a6a8ad;font-size:12px}
.muted{color:var(--muted)}
.btn{display:inline-flex;gap:10px;align-items:center;padding:12px 16px;border-radius:12px;border:0;background:var(--acc);color:#fff;font-weight:700;text-decoration:none;cursor:pointer}
.btn.secondary{background:#1b2440;border:1px solid #2a3046}
.actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px}
.me{margin-top:12px;padding:10px 12px;border:1px solid #1e2536;background:#0f1422;border-radius:12px;display:flex;align-items:center;justify-content:space-between}
.me code{background:#12182a;border:1px solid #203054;border-radius:6px;padding:2px 6px;margin-left:6px}
.pill{padding:4px 8px;border-radius:999px;background:#243a2e;color:#b6f7c7;font-size:12px}
.logo{width:20px;height:20px}
`
